import axios from "./../../config/axios";

function store(data) {
    return axios().post("/sales-scheduling/activities", data)
}

function all(scheduleId) {
    return axios().get("/sales-scheduling/activities", {
        params: {
            schedule_id: scheduleId
        }
    })
}

export default {
    store,
    all
}